import AppSystemWebApiResourcePagingResultModel from '../../generated/types/model/resource/AppSystemWebApiResourcePagingResultModel';

export default class AppSystemWebApiResourcePagingResultViewModel extends AppSystemWebApiResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
